import { FC, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { CustomModal } from '@mybonum/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Flex } from 'antd';

import { normalizeToApi } from '../../utils/normalize-to-api.ts';
import { AdminForm, TAdminFormValues } from '../form';

import { FORM_ID } from './constants.ts';

import { useMessage } from '@/hooks/use-message.ts';
import { API } from '@/services/api';

export const AdminCreate: FC = () => {
    const [open, setOpen] = useState<boolean>(false);
    const queryClient = useQueryClient();
    const { message } = useMessage();
    const handleClose = (): void => setOpen(false);
    const handleOpen = (): void => setOpen(true);

    const { mutateAsync: createAdmin, isPending } = useMutation({
        mutationFn: API.ADMINS.createAdmin,
        onError: async (error) => {
            await message.error(error.message || 'Something went wrong...');
        },
    });

    const handleSubmit = async (values: TAdminFormValues): Promise<void> => {
        await createAdmin(normalizeToApi(values));
        await queryClient.invalidateQueries({ queryKey: API.ADMINS.getAdmins().queryKey });
        handleClose();
        message.success('Admin created successfully');
    };

    return (
        <div>
            <Button type="primary" icon={<PlusOutlined />} onClick={handleOpen}>
                Create admin
            </Button>
            <CustomModal
                width={400}
                open={open}
                padding="small"
                onCancel={handleClose}
                title="Create admin"
                footer={
                    <Flex gap={16} justify="space-between">
                        <Button
                            danger
                            onClick={() => {
                                handleClose();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button form={FORM_ID} htmlType="submit" type="primary" loading={isPending}>
                            Create
                        </Button>
                    </Flex>
                }
            >
                <AdminForm onFinish={handleSubmit} id={FORM_ID} />
            </CustomModal>
        </div>
    );
};
